// APP ENTRY POINT

import Vue from "vue";
import VueRouter from "vue-router";
import VueFormGenerator from "vue-form-generator";
import { createCssPackSheets } from "./assets/js/cssPackSheets.js";
import { registerCssPackSheets, bootCssPacks } from "./assets/js/cssPacks.js";
// // Fix between local and exported project
// if (VueFormGenerator.default) {
// 	VueFormGenerator = VueFormGenerator.default;
// }



// import Autocomplete from 'v-autocomplete';
var VueScrollTo = require("vue-scrollto");

// TODO don't think this is needed any more?
Vue.use(VueRouter);
Vue.use(VueScrollTo);

// import fieldAceeditor from './assets/components/layouts/formGen/custom/aceeditor.vue';


const {
  fieldCheckbox,
  fieldChecklist,
  fieldInput,
  fieldLabel,
  fieldRadios,
  fieldSelect,
  fieldSubmit,
  fieldTextArea,
  fieldUpload,
  fieldCleave,
  fieldDateTimePicker,
  fieldGoogleAddress,
  fieldImage,
  fieldMasked,
  fieldNoUiSlider,
  fieldPikaday,
  fieldRangeSlider,
  fieldSelectEx,
  fieldSpectrum,
  fieldStaticMap,
  fieldSwitch,
  fieldVueMultiSelect
} = VueFormGenerator.fieldsLoader;
import _ from 'lodash';
Vue.prototype._ = _

Vue.use(VueFormGenerator, {
  fields: [
    
    // fieldAceeditor,
    
    fieldCheckbox,
    fieldChecklist,
    fieldInput,
    fieldLabel,
    fieldRadios,
    fieldSelect,
    fieldSubmit,
    fieldTextArea,
    fieldUpload,
    fieldCleave,
    fieldDateTimePicker,
    fieldGoogleAddress,
    fieldImage,
    fieldMasked,
    fieldNoUiSlider,
    fieldPikaday,
    fieldRangeSlider,
    fieldSelectEx,
    fieldSpectrum,
    fieldStaticMap,
    fieldSwitch,
    fieldVueMultiSelect
]
})

window.VueFormGenerator = VueFormGenerator; // needed for form validators
window.Vue = Vue;

// JQUERY
var jQuery = require("jquery");
window.$ = window.jQuery = window.jquery = jQuery;

// eonasdan-bootstrap-DATETIMEPICKER
var datetimepicker = require("eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min.js");
window.datetimepicker = datetimepicker;

// TWITTER BOOTSTRAP
require("bootstrap");

// TEMPLATE LEGACY JS
var appLegacy = require("Js/appLegacy");
window.appLegacy = appLegacy;


/*===================================================*/


console.time('LOAD_SITE_MODEL')

registerCssPackSheets(createCssPackSheets());
bootCssPacks();

// STORE
import store from "Js/store";
// ROUTER
import router from "Js/routes.js";
// FEATHERS
import "Js/feathers";
// BF function library
import "Js/BF";
// Expose BF as an instance property so templates in any component can use `BF.*`
Vue.prototype.BF = window.BF;

import './registerServiceWorker.js'

// GLOBAL COMPONENTS
import VRuntimeTemplate from "v-runtime-template";
Vue.component("html-renderer", VRuntimeTemplate);
Vue.component ("app" , require("@/assets/components/masters/app.vue").default)

// Trap duplicate router issue
const originalPush = router.push;
router.push = function(location, onResolve, onReject) {
  return originalPush.call(this, location, onResolve, onReject).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

// VUE
var app = new Vue({
  store: store,
  el: "#app",
  router: router,
  
}).$mount("#app");

// Vue.config.errorHandler = function (err, vm, info) {
//     BF.errorThrow (10040, 'BF global errorHandler (See info for details)' , {err, info})
//     return false
// };
// Vue.config.warnHandler = function (err, vm, info) {
//     BF.errorThrow (10042, 'BF global warnHandler (See info for details)' , {err, info})
//     return false
// };

Vue.config.devtools = true; 
window.vueapp = app;

const originalConsoleWarn = console.warn;

// Override the console.warn method
console.warn = function(message, ...optionalParams) {
  if (!message.startsWith('cdn.tailwindcss.com should not be used in production.')) {
    originalConsoleWarn.apply(console, [message, ...optionalParams]);
  }
};